import React from 'react'
import CircularProgress from '@mui/material/CircularProgress';
import './Lodder.css'
function Lodder() {
  return (
    <div className='lodder-container'>
      <CircularProgress  />
    </div>
  )
}

export default Lodder
